import { styled } from '@mui/material/styles'
import CSS from 'csstype'

type StyleProps = {
  backgroundColor?: CSS.Property.BackgroundColor
  height?: CSS.Property.Height
  width?: CSS.Property.Width
  backgroundImage?: CSS.Property.BackgroundImage
}

type Props = {
  copy?: string
  styles?: StyleProps
  isAnimationDisabled?: boolean
  shimmerWidth?: string
}

export const SkeletonLoader: React.FC<Props> = ({
  copy,
  styles,
  shimmerWidth,
  isAnimationDisabled,
}) => {
  // regex to  remove  px or % from end of shimmerWidth
  let translateValue = 100
  if (shimmerWidth) {
    translateValue = Math.round(
      100 * (100 / parseInt(shimmerWidth?.replace(/(px|%)/g, '') || '100', 10))
    )
  }

  return (
    <Container
      styles={styles}
      shimmerWidth={shimmerWidth}
      translateValue={translateValue}
      isAnimationDisabled={isAnimationDisabled}
    >
      {copy}
    </Container>
  )
}

const Container = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'isAnimationDisabled' &&
    prop !== 'translateValue' &&
    prop !== 'shimmerWidth',
})<{
  styles?: StyleProps
  isAnimationDisabled?: boolean
  shimmerWidth?: string
  translateValue?: number
}>`
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  width: ${({ styles }) => styles?.width || '100%'};
  height: ${({ styles }) => styles?.height || '100%'};
  background-color: ${({ styles }) => styles?.backgroundColor || '#e4e4e4'};

  display: flex;
  justify-content: center;
  align-items: center;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    animation: shimmer-${({ translateValue }) => translateValue} 2s linear infinite;
    background-image: linear-gradient(
      90deg,
      rgba(246, 247, 250, 0),
      rgba(246, 247, 250, 0.4) 33%,
      rgba(246, 247, 250, 0.7) 66%,
      rgba(246, 247, 250, 0)
    );
    width: ${({ shimmerWidth }) => shimmerWidth || '100%'};
    ${({ styles }) =>
      styles?.backgroundImage && `background-image: ${styles.backgroundImage}`};
    ${({ isAnimationDisabled }) => !isAnimationDisabled && 'content: "";'};
  }

  @keyframes shimmer-${({ translateValue }) => translateValue} {
    0% {
      transform: translateX(-100%);
    }
    100% {
      // 100% / shimmerWidth converted to %
      transform: ${({ translateValue }) => `translateX(${translateValue}%)`};
    }
  }
`
